import { render, staticRenderFns } from "./TheoryExamInfo.vue?vue&type=template&id=72a462e3"
import script from "./TheoryExamInfo.vue?vue&type=script&lang=ts"
export * from "./TheoryExamInfo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports